import { render, staticRenderFns } from "./AMCexercise.vue?vue&type=template&id=136dd3b8&scoped=true"
import script from "./AMCexercise.vue?vue&type=script&lang=js"
export * from "./AMCexercise.vue?vue&type=script&lang=js"
import style0 from "./AMCexercise.vue?vue&type=style&index=0&id=136dd3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136dd3b8",
  null
  
)

export default component.exports